import * as React from "react";
const SvgIcCodeTags = props => <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M12.167 13.833 16 10l-3.833-3.833L13.333 5l5 5-5 5-1.166-1.167Zm-4.334 0L4 10l3.833-3.833L6.667 5l-5 5 5 5 1.166-1.167Z" /></svg>;
export default SvgIcCodeTags;